import { createSlice } from "@reduxjs/toolkit";

interface DesktopMapSection {
  action: string;
  currentInventoryIndex: number;
  currentFocusedInventory: number;
}

export const initialState: DesktopMapSection = {
  action: "",
  currentInventoryIndex: -1,
  currentFocusedInventory: -1,
};

const desktopMap = createSlice({
  name: "desktopMap",
  initialState,
  reducers: {
    setHoveredInventory: (state, { payload }) => {
      state.action = payload.action;
      state.currentInventoryIndex = payload.index;
    },
    removeHoveredInventory: (state, { payload }) => {
      state.action = payload.action;
      state.currentInventoryIndex = payload.index;
    },
    setFocusedInventory: (state, { payload }) => {
      state.action = payload.action;
      state.currentFocusedInventory = payload.inventoryId;
    },
  },
});

export default desktopMap.reducer;
export const { setHoveredInventory, removeHoveredInventory, setFocusedInventory } =
  desktopMap.actions;
